import React from 'react';
import roku from '../img/roku.png';
import IconBadge from './IconBadge';

const Badge: React.FC<React.PropsWithChildren<unknown>> = props => (
  <IconBadge url={roku.src} {...props} />
);

export default Badge;
